import { render, staticRenderFns } from "./FormDictamen.vue?vue&type=template&id=a1a39c90"
import script from "./FormDictamen.vue?vue&type=script&lang=js"
export * from "./FormDictamen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports